export default class ResultsSummaryController {
  /* @ngInject */
  constructor($log, DictionaryService, ConfigurationService) {
    this.$log = $log;
    this.authorable = ConfigurationService.getConfiguration();
    this.solutionDictionaryLookup = DictionaryService.solutionDictionaryLookup;
  }

  $onInit() {
    this.companySize = `${this.data.myCompanySize} Employees`;
    if (this.data.myLocation) {
      this.processLocation();
    }

    if (this.data.multiCoverage) {
      this.processMultipleStates(this.data.multiCoverage);
    }
    this.processSolutions();
  }

  processSolutions() {
    const solutionsFromData = Object.keys(this.data.solutions);
    this.solutions = solutionsFromData.map(solution => this.solutionDictionaryLookup(solution, 'name'));
  }

  processMultipleStates(states) {
    this.selectedStates = Object.keys(states).sort().join(', ');
  }

  processLocation() {
    this.location = this.data.myLocation.split(',');
    this.location[0] = this.location[0].toLowerCase();
    this.location = this.location.join(', ');
  }

}



// WEBPACK FOOTER //
// ./src/components/results-summary/results-summary.controller.js